import { Tab } from "@headlessui/react";
import { useEffect, useState } from "react";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { convertCamelCaseToTitleCase } from "js/formatting";

import PolicyAlertsTab from "./PolicyAlertsTab";
import CompanyAlertsTab from "./CompanyAlertsTab";
import CorrespondenceTab from "./CorrespondenceTab";

export default function Messages() {
  const { t } = useTranslation();
  const MESSAGES_TAB_LIST = {
    companyAlerts: 0,
    documents: 1,
    contractAlerts: 2,
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedTabIndex, setSelectedTabIndex] = useState(
    searchParams.get("tab") ? MESSAGES_TAB_LIST[searchParams.get("tab")] : 0
  );
  const [selectedPolicyId, setSelectedPolicyId] = useState(
    searchParams.get("id") ?? "all"
  );
  const selectedCategory = searchParams.get("category") ?? null;

  useBreadcrumb([
    { name: "Home", url: "/dashboard" },
    { name: "Alerts & Documents", url: "#" },
  ]);

  return (
    <>
      <div className="container mb-8">
        <h1>{t("AlertsCorrespondence-title")}</h1>
        <p>{t("AlertsCorrespondence-subTitle")}</p>
        <hr />
      </div>

      <div className="container ui-component-spacing h-full min-h-[120px]">
        <div className="flex flex-row items-start">
          <div className="w-full">
            <Tab.Group
              selectedIndex={selectedTabIndex}
              onChange={setSelectedTabIndex}
            >
              <div className="flex flex-col lg:flex-row lg:items-center">
                <div className="ui-card flex-grow px-2 p-1 md:px-4">
                  <Tab.List>
                    {Object.keys(MESSAGES_TAB_LIST).map((tabName) => (
                      <Tab
                        key={tabName}
                        className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg `}
                      >
                        {({ selected }) => (
                          <span
                            className={selected ? "text-black" : "text-ui-blue"}
                          >
                            {convertCamelCaseToTitleCase(t(tabName))}
                          </span>
                        )}
                      </Tab>
                    ))}
                  </Tab.List>
                </div>
              </div>
              <Tab.Panels>
                {selectedTabIndex === 0 && <CompanyAlertsTab />}
                {selectedTabIndex === 1 && (
                  <CorrespondenceTab
                    selectedPolicyId={selectedPolicyId}
                    setSelectedPolicyId={setSelectedPolicyId}
                    selectedCategory={selectedCategory}
                  />
                )}
                {selectedTabIndex === 2 && (
                  <PolicyAlertsTab
                    selectedPolicyId={selectedPolicyId}
                    setSelectedPolicyId={setSelectedPolicyId}
                  />
                )}
              </Tab.Panels>
            </Tab.Group>
          </div>
        </div>
      </div>
    </>
  );
}
